import { CardItem } from '../components/CardItem';
import { Section } from '../components/Section';
import { rainLocator } from '../constants/rain-locator';

export default function LocalizacaoChuvas() {
  return (
    <Section className="justify-content-center">
      <h2 className="text-center fw-normal mb-4 pb-2">
        Localização das Chuvas
      </h2>
      {rainLocator?.map((item, index) => (
        <CardItem key={index} item={item} className="col-lg-4" />
      ))}
    </Section>
  );
}
